import thunkReducerFactory from "infrastructure/store/reducers/thunkReducerFactory";

export const {
    requestLoading: kycRequestLoading,
    requestFulfilled: kycRequestFulfilled,
    requestRejected: kycRequestRejected
} = thunkReducerFactory();
